// This is use to hide sensitive data (i.e Phone Numbers / AC number)
const generateHiddenText = (text: string) => {
  let hiddenText = '';

  for (let i = 1; i <= String(text)?.length; i + 1) {
    hiddenText += 'x';
  }

  return hiddenText;
};

const getEnvironment = () => {
  let host = window.location.host;
  if (host.startsWith("local")) {
    return "local";
  } else if (host.startsWith("aries")) {
    return "automation";
  } else if (host.startsWith("bootes")) {
    return "beta";
  } else if (host.startsWith("draco") || host.startsWith("gemini") || host.startsWith("orion")) {
    return "development";
  } else if (host.startsWith("taurus")) {
    return "qa";
  } else if (host.startsWith("staging")) {
    return "staging";
  } else {
    return "production";
  }
}

// eslint-disable-next-line import/prefer-default-export
export { generateHiddenText, getEnvironment };
